<template>
  <div class="app-container">
    <div class="screeBox">
      <!-- <el-select
        filterable
        v-if="userInfo.park_id == 0"
        v-model="screen.park_id"
        placeholder="请选择园区"
      >
        <el-option label="全部" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select> -->
      <el-input
        class="screenInput"
        v-model="screen.title"
        placeholder="请输入角色名称"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>
<!-- 
    <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/role/add')"
        >添加角色</el-button
      >
      <el-button
        size="medium"
        type="danger"
        @click="delUser()"
        v-if="roles.includes('/role/add')"
        >删除角色</el-button
      >
    </div> -->
    <el-table
      max-height="700"  v-loading="listLoading" 
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <!-- <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.park">{{ scope.row.park.name }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="所属企业" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.company && scope.row.type == 2">{{
            scope.row.company.name
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="角色名称" min-width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.title }}</div>
        </template>
      </el-table-column>
      <el-table-column label="角色类型" min-width="110" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1 ? "园区" : scope.row.type == 4 ? "住宅" : "企业"
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="关系所属" min-width="110" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.role_type == 1 ? "后台" : "小程序" }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.role_type == 1 ? '后台' : '小程序' }}</span> -->
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="260" fixed="right">
        <template slot-scope="scope">
          <el-button
            class="szqxBtn"
            type="primary"
            v-if="roles.includes('/role/set_mini_auth')"
            size="mini"
            @click="setQx(scope.row.id, 'xcx')"
            >设置小程序权限</el-button
          >
          <!-- <el-button
            style="margin-right: 10px"
            type="primary"
            v-if="roles.includes('/role/set_auth')"
            size="mini"
            @click="setQx(scope.row.id, 'app')"
            >设置APP权限</el-button
          >
          <el-button
            class="btnTop"
            size="mini"
            type="warning"
            v-if="
              scope.row.is_super != 1 &&
              roles.includes('/role/info') &&
              scope.row.is_default != 1 &&
              scope.row.is_default != 2 &&
              scope.row.is_default != 3
            "
            @click="handleSee(scope.row)"
            >查看</el-button
          >
          <el-button
            class="btnTop"
            size="mini"
            type="success"
            v-if="
              scope.row.is_super != 1 &&
              roles.includes('/role/edit') &&
              scope.row.is_default != 1 &&
              scope.row.is_default != 2 &&
              scope.row.is_default != 3
            "
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            class="btnTop"
            size="mini"
            type="danger"
            v-if="
              scope.row.is_super != 1 &&
              roles.includes('/role/del') &&
              scope.row.is_default != 1 &&
              scope.row.is_default != 2 &&
              scope.row.is_default != 3
            "
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="600px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="角色名称" prop="title">
          <el-input
            v-model="ruleForm.title"
            :disabled="cztype == 'see'"
            placeholder="请输入账号名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="角色类型" prop="type">
          <el-radio-group v-model="ruleForm.type" :disabled="cztype != 'add'">
            <el-radio :label="1">园区</el-radio>
            <el-radio :label="2">企业</el-radio>
            <el-radio :label="4">住宅</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype != 'add' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <template v-if="cztype != 'add'">
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in infoParkList"
                :key="index"
              ></el-option>
            </template>
            <template v-else>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in parkList"
                :key="index"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="企业" prop="company_id" v-if="ruleForm.type == 2">
          <el-select
            filterable
            v-model="ruleForm.company_id"
            placeholder="请选择企业"
            :disabled="cztype == 'see'"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in companyList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="关系所属" prop="role_type">
          <el-radio-group
            v-model="ruleForm.role_type"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">后台</el-radio>
            <el-radio :label="2">小程序</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="排序" prop="sort">
          <el-input
            type="number"
            v-model="ruleForm.sort"
            :disabled="cztype == 'see'"
            placeholder="请输入排序"
            class="numInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否超级管理员角色" prop="is_super">
          <el-select filterable 
            v-model="ruleForm.is_super"
            placeholder="是否超级管理员"
            :disabled="cztype == 'see'"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="ruleForm.remark"
            :disabled="cztype == 'see'"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="cztype == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog title="权限设置" :visible.sync="qxdrawer">
      <tree-transfer
        :checkStrictly="false"
        :title="title"
        :from_data="fromData"
        :to_data="toData"
        :defaultProps="{ label: 'title', children: 'nodes' }"
        @addBtn="add"
        @removeBtn="remove"
        :mode="mode"
        height="400px"
      >
      </tree-transfer>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qxdrawer = false">取 消</el-button>
        <el-button
          v-if="qxType == 1"
          type="primary"
          @click="xcxSet()"
          :disabled="qxSet"
          >确 定</el-button
        >
        <el-button
          v-if="qxType == 2"
          type="primary"
          @click="appSet()"
          :disabled="qxSet"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  miniRoleList,
  miniAddRole,
  miniEditRole,
  miniDelRole,
  miniInfoRole,
  miniGetAuth,
  miniSetRole,
  xcxSetRole,
  openPark,
  openCompany,
  openMenu,
} from "@/api/index";
import { getToken } from "@/utils/auth";
import treeTransfer from "el-tree-transfer";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo"]),
  },
  components: { treeTransfer },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      qxSet: false,
      title: ["待选", "已选"],
      mode: "transfer",
      fromData: [],
      toData: [],
      rightIds: [],
      qxdrawer: false,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加角色",
      token: getToken(),
      total: 0,
      screen: {
        is_page: 1,
        is_tree: 1,
        page: 1,
        page_size: 15,
        role_type: 2,
        type: "",
        park_id: "",
        title: "",
      },
      ruleForm: {
        title: "",
        type: "",
        role_type: 2,
        park_id: "",
        sort: "",
        status: 1,
        is_super: 0,
        level: "",
        remark: "",
        company_id: "",
      },
      rules: {
        title: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
        type: [
          { required: true, message: "请选择角色类型", trigger: "change" },
        ],
        role_type: [
          { required: true, message: "请选择关系所属", trigger: "change" },
        ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
      },
      multipleSelection: [],
      cztype: "",
      oldImg: "",
      qxId: "",
      qxType: "",
      qxParkId: "",
      parkList: [],
      companyList: [],
      infoParkList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      // this.screen.type = this.userInfo.type;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    chongZhi() {
      this.screen = {
        is_page: 1,
        is_tree: 1,
        page: 1,
        page_size: 15,
        role_type: 2,
        type: "",
        park_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
        // this.screen.type = this.userInfo.type;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    parkChange() {
      this.getCompany();
      this.ruleForm.company_id = "";
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 设置APP权限
    appSet() {
      this.qxSet = true;
      var ids = this.getRightDataIds(this.toData, []);
      miniSetRole({
        role_id: this.qxId,
        menu_ids: ids.toString(),
        park_id: this.qxParkId,
      })
        .then((res) => {
          this.qxSet = false;
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
          }
          this.qxdrawer = false;
        })
        .catch((err) => {
          this.qxSet = false;
        });
    },
    // 设置小程序权限
    xcxSet() {
      this.qxSet = true;
      var ids = this.getRightDataIds(this.toData, []);
      xcxSetRole({
        role_id: this.qxId,
        menu_ids: ids.toString(),
        park_id: this.qxParkId,
      }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
        }
        this.qxdrawer = false;
        this.qxSet = false;
      });
    },
    // 获取右侧数据 id
    getRightDataIds(list, rightIds) {
      for (var rightItem of list) {
        rightIds.push(rightItem.id);
        if (rightItem.nodes && rightItem.nodes.length) {
          this.getRightDataIds(rightItem.nodes, rightIds);
        }
      }
      return rightIds;
    },
    // 处理过滤数据
    getFilterLeftData() {
      const rightIds = this.getRightDataIds(this.toData, []);
      // this.fromData = this.filterLeftData(this.fromData, rightIds, []);
      this.fromData = this.globalfunc.filterLeftData(
        this.fromData,
        rightIds,
        []
      );
    },
    // 设置权限
    setQx(id, type) {
      this.qxId = id;
      miniInfoRole({ id: id }).then((res) => {
        this.qxParkId = res.data.info.park_id;
        if (res.data.info.is_super == 1) {
          this.getAuth(
            res.data.info.id,
            res.data.info.id,
            res.data.info.type,
            type
          );
        } else {
          this.getAuth(
            res.data.info.park_id,
            res.data.info.id,
            res.data.info.type,
            type
          );
        }
      });
    },
    getMenu() {
      openMenu().then((res) => {
        this.fromData = res.data.lists;
      });
    },
    async getAuth(parkId, id, xcx_Mode, type) {
      let menu_type = "";
      let xcxMode = "";
      if (type == "app") {
        xcxMode = "";
        this.qxType = 2;
        menu_type = 3;
      } else if (type == "xcx") {
        // if (xcx_Mode == 4) {
        //   xcxMode = 2;
        // } else {
        //   xcxMode = 1;
        // }
        this.qxType = 1;
        menu_type = 2;
      }
      await openMenu({
        status: 1,
        is_page: 2,
        is_tree: 2,
        menu_type: menu_type,
        // xcx_mode: xcxMode,
      }).then((res) => {
        this.fromData = res.data.lists;
      });
      await miniGetAuth({
        role_id: id,
        show_type: 2,
        is_tree: 2,
        menu_type: menu_type,
        park_id: parkId,
      }).then((res) => {
        this.toData = res.data.lists;
      });
      this.getFilterLeftData();
      this.qxdrawer = true;
      // setTimeout(() => {
      // }, 1000)
    },
    // 监听穿梭框组件添加
    add(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
    },
    // 监听穿梭框组件移除
    remove(fromData, toData, obj) {
      // 树形穿梭框模式transfer时，返回参数为左侧树移动后数据、右侧树移动后数据、移动的{keys,nodes,halfKeys,halfNodes}对象
      // 通讯录模式addressList时，返回参数为右侧收件人列表、右侧抄送人列表、右侧密送人列表
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              miniEditRole(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val));
      // this.ruleForm.id = val.id;
      (this.ruleForm = {
        id: val.id,
        title: val.title,
        type: val.type,
        role_type: val.role_type,
        park_id: val.park_id,
        sort: val.sort,
        status: val.status,
        is_super: val.is_super,
        level: val.level,
        remark: val.remark,
        company_id: val.company_id,
        pid: val.pid,
      }),
        (this.infoParkList = []);
      this.infoParkList.push(val.park);
      this.getCompany();
      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      this.ruleForm = val;
      this.infoParkList = [];
      this.infoParkList.push(val.park);
      this.drawer = true;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then((_) => {
          miniDelRole({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then((_) => {
              miniAddRole(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch((_) => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
        })
        .catch((_) => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加角色";
      this.cztype = "add";
      this.ruleForm = {
        pid: id,
        title: "",
        type: 1,
        role_type: 2,
        park_id: "",
        sort: 0,
        status: 1,
        is_super: 0,
        level: "",
        remark: "",
        company_id: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取企业
    getCompany() {
      openCompany({ park_id: this.ruleForm.park_id, is_page: 2 }).then(
        (response) => {
          this.companyList = response.data.lists;
        }
      );
    },
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delUser() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个角色");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          miniDelRole({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      miniRoleList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
  .el-button + .el-button,
  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0px;
    margin-right: 10px;
  }
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.dialog-footer {
  text-align: center;
}
::v-deep .transfer-title {
  margin: 0;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.btnTop {
  margin-top: 10px;
}
.szqxBtn {
  background: #40caff;
  margin-right: 10px;
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
